/**
 * What Presenting hides (founder 6441608339, the demo walk of 2026-10-27).
 *
 * ⌘K "Keystone" listed the per-person and rehearsal copies of the demo project beside it:
 * "Keystone Valley OnBase Implementation (Bob)", "(Rehearsal A)"… A copy is named "<source> (<who>)",
 * so under Presenting a project result whose name is another result's name plus a "(…)" suffix is
 * hidden, and so is any "(Rehearsal …)", "(Dry run …)" or "(Fix proof …)" copy.
 */
const COPY_SUFFIX = / \([^()]*\)$/;
const THROWAWAY = /\((Dry run|Fix proof|Rehearsal)/i;

// The palette's results carry a display label in `type` ("Project"); search API rows carry `entity_type`
// ("project"). Either names a project. Reading only entity_type let every copy through on the live palette.
const isProject = (r: { entity_type?: string; type?: string }) =>
  (r.entity_type ?? r.type ?? "").toLowerCase() === "project";

export function withoutProjectCopies<T extends { entity_type?: string; type?: string; title?: string }>(
  results: T[],
): T[] {
  const names = new Set(results.filter(isProject).map((r) => (r.title ?? "").trim()));
  return results.filter((r) => {
    if (!isProject(r)) return true;
    const title = (r.title ?? "").trim();
    if (THROWAWAY.test(title)) return false;
    const stem = title.replace(COPY_SUFFIX, "");
    return !(stem !== title && names.has(stem));
  });
}

/**
 * Felix-feed items Presenting holds back (row 053c7759, founder 6452959310): on 2026-10-27 an API
 * error woke the Ask Felix panel during a shared screen and it showed meeting-intelligence pushes,
 * "⚠ Conflict (statement vs statement): …" and "⚠ Scope drift detected (…): … fixed price of
 * $691,413". An internal alert (it starts with ⚠) or any money, margin or AI-cost figure is ours
 * alone; it waits until Presenting is turned off.
 */
const INTERNAL_ALERT = /^\s*⚠/;
const MONEY_OR_MARGIN = /[$€£]\s?\d|\b(?:USD|EUR|GBP)\s?\d|\b\d[\d,.]*\s?(?:USD|EUR|GBP)\b|\bmargin\b|\bAI (?:cost|spend)\b/i;

export function isInternalFeedItem(text: string | null | undefined): boolean {
  const t = text ?? "";
  return INTERNAL_ALERT.test(t) || MONEY_OR_MARGIN.test(t);
}
